import cn from "classnames";

import { Blocks } from "@/components/blocks/blocks.component";
import { Text } from "@/components/text/text.component";

import { brown } from "@/app/font";

/** Price Component */
export const Price = ({
  value,
  className,
  free,
  freeText = "FREE",
  loading,
  loadingLines = 1,
  loadingClassName,
  monthly = false,
  primary = false,
  ...rest
}: PriceProps) => {
  // Check loading state
  if (loading) {
    return <Blocks blocks={loadingLines} className={loadingClassName} />;
  }
  if (free) {
    return (
      <div
        data-testid="price-free"
        {...rest}
        className={cn(className, "text-success")}>
        {freeText}
      </div>
    );
  }
  if (!value) return null;
  // USD is always formatted with en-US so display matches regardless of the runtime/OS locale (CI and dev machines vary).
  const formattedPrice = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);

  return (
    <div
      data-testid="price"
      {...rest}
      className={cn(className, "flex items-center whitespace-nowrap", {
        [brown.className]: primary,
      })}>
      {formattedPrice}
      {monthly ? (
        <Text className="inline" data-testid="price-monthly">
          /mo
        </Text>
      ) : null}
    </div>
  );
};

export type PriceProps = {
  className?: string;
  value?: number | null;
  free?: boolean;
  freeText?: string;
  loading?: boolean;
  loadingLines?: number;
  loadingClassName?: string;
  monthly?: boolean;
  primary?: boolean;
};
